import { SET_TOTAL_REVIEW_PENDING_ITEMS } from "../../redux/actions/action.types";

export default function setTotalRPItems(valueSetter: any, value: any) {
  valueSetter({
    type: SET_TOTAL_REVIEW_PENDING_ITEMS,
    payload: value,
  });
}
